var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('ul',_vm._l((_vm.value),function(item,index){return _c('li',{key:item.link + index},[_c('a',{attrs:{"href":item.link}},[_vm._v(" "+_vm._s(item.title)+" ")]),_c('site-map-list',{attrs:{"value":item.childs}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }